import React from 'react'
import PropTypes from 'prop-types'
import { Field, CustomLoading, StyledHint } from './styles'

const InputText = (props) => {
  const {
    style,
    label,
    value,
    name,
    onChange,
    type,
    onBlur,
    isRequired,
    className,
    isLoading,
    isDisabled,
    isError,
    isSuccess,
    hint,
    size,
    step,
    placeholder,
  } = props

  const renderType = () => {
    if (isSuccess) return 'success'
    if (isError) return 'alert'
    return ''
  }

  return (
    <Field className={className}>
      <span>
        {Boolean(label) && label}
        {isRequired && (
          <i className="fas fa-asterisk" title="campo obrigatorio"/>
        )}
      </span>
      <input
        name={name}
        style={style}
        id={name}
        value={value}
        onChange={onChange}
        type={type}
        className={renderType()}
        onBlur={onBlur}
        required={isRequired}
        disabled={isDisabled || isLoading}
        placeholder={placeholder}
        autoComplete={name}
        maxLength={size}
        size={size}
        step={step}
      />
      {isLoading && (
        <CustomLoading className="fas fa-spinner" />
      )}
      {(isError && !isSuccess) && (
        <StyledHint className={isSuccess ? 'success' : ''}>
          {hint}
        </StyledHint>
      )}
    </Field>
  )
}

InputText.propTypes = {
  style: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.Number,
  step: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hint: PropTypes.string,
  placeholder: PropTypes.string,
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
}

InputText.defaultProps = {
  type: 'text',
  onBlur: null,
  isRequired: false,
  className: '',
  label: '',
  isLoading: false,
  isDisabled: false,
  hint: '',
  placeholder: '',
  isError: false,
  isSuccess: false,
  step: 60,
}

export default InputText
